import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../../actions/ApiGo';
import WaitingIcon from '../../../Login/wait/WaitingICON';
import ConnectionList from './Connectionlist';
import Connection_His from './Connection_His';

// const ONE_DAY = 86400000
const ONE_DAY = 43200000
const ConnectionHisGraphyNew =(props)=>{
    const {t}=useTranslation()
    const _timestamp = new Date()
    const [mix_row, setMix_row] = useState([]);
    const [nameRow, setNameRow] = useState(null);
    const [mixTimeDataStructure, setMixTimeDataStructure] = useState(null);
    const [time_interval, setTime_interval] = useState([]);
    const [ConnectionRecord, setConnectionRecord] = useState([false, ""]);
    const [userArray, setUserArray] = useState([]);

    function toggleConRec(name){
        setConnectionRecord([false, ""])
        setTimeout(()=>{ setConnectionRecord([true, name]) }, [10])
    }
    useEffect(()=>{
        const _10Minutes = Array.from(Array(720).keys())
        let _row = []
        _10Minutes.forEach(res=>{
            let _end_time = _timestamp.getTime()            // interval end
            let _start_time = _end_time - ONE_DAY           // interval start
            let this_preiod = _start_time + (res+1)*(ONE_DAY/720)
            _row.push(this_preiod)
        })
        setTime_interval(_row)
        fetch_user()
        fetch_device_connection_login()
        .then(fetch_device_connection_logout)
        .catch(err=>{console.log();})
        return(()=>{
            setMix_row([])
            setNameRow(false)
            setMixTimeDataStructure(null)
        })
    },[])

    function fetch_user(){
        ApiGo.getUsers()
        .then(res=>{setUserArray(res.users)})
        .catch(err=>{console.log(err);})
    }

    function fetch_device_connection_login(){
        let _nameRow = []
        let _mixTimeRow = []
        return new Promise((reolve, reject)=>{
            ApiGo.getDevice_connection_record_login()
            .then(res=>{
                const timestamp_now = new Date().getTime()
                res.forEach(row=>{
                    row.created_at = Date.parse(row.created_at)
                    row.login_time =row.login_time.split("T")[0] + " " + row.login_time.split("T")[1]
                    let _inOneDay = timestamp_now - row.created_at
                    // 判斷一天以上的刪掉
                    if(_inOneDay > ONE_DAY){ return }
                    // 開始整理每個user資料
                    let _index = _nameRow.indexOf(row.user_name)
                    if(_index===-1){
                        _nameRow.push(row.user_name)
                        _mixTimeRow.push([row])
                    }else{
                        _mixTimeRow[_index].push(row)
                    }
                })
                reolve([_nameRow, _mixTimeRow])
            })
            .catch(err=>{reject(err)})
        })
    }
    function fetch_device_connection_logout(array){
        let _nameRow = array[0]
        let _mixTimeRow = array[1]
        ApiGo.getDevice_connection_record_logout()
        .then(res=>{
            const timestamp_now = new Date().getTime()
            res.forEach(row=>{
                row.created_at = Date.parse(row.created_at)
                row.logout_time =row.logout_time.split("T")[0] + " " + row.logout_time.split("T")[1]
                let _inOneDay = timestamp_now - row.created_at
                // 判斷一天以上的刪掉
                if(_inOneDay > ONE_DAY){ return }
                // 開始整理每個user資料
                let _index = _nameRow.indexOf(row.user_name)
                if(_index===-1){
                    _nameRow.push(row.user_name)
                    _mixTimeRow.push([row])
                }else{
                    _mixTimeRow[_index].push(row)
                }
            })
            setNameRow(_nameRow)
            setMixTimeDataStructure(_mixTimeRow)
        })
        .catch(err=>{
            setMix_row("no_data")
        })
    }

    useEffect(()=>{
        let _arr = mixTimeDataStructure
        if(_arr===null){return}
        _arr.forEach(res=>{
            res.sort((a,b)=>{
                if(a.created_at < b.created_at) return 1
                if(b.created_at < a.created_at) return -1
                return 0;
            })
        })
        setMix_row(_arr)
    }, [mixTimeDataStructure])
    return(
        <div className="font-ml h-100">
            <ConnectionList mos={props.mos}/>
            <div className='wid-admin-90 fx-d-c bgC-white br-20 margb-xxs pad-15 t b shadow-s-noHover'>
                <div className='w-90 fx-d-r fx-cspbt'>
                    <div className="font-l margl-xxs">{t("ADMIN.CONNECTION_HIS_PAGE.CONNECTION_HIS")}</div>
                    <div className='w-40 fx-d-r'>
                        <div className='fx-d-r w-50 fx-cspar'>
                            <div className='w-20 h-50 bgC-light-green right_border left_border'></div>
                            <div className='w-80 margl-s'>{t("ADMIN.CONNECTION_HIS_PAGE.LOGIN_PERIOD")}</div>
                        </div>
                        <div className='fx-d-r w-50 fx-cspar margl-l'>
                            <div className='w-20 h-50 bgC-white right_border left_border'></div>
                            <div className='w-80 margl-s'>{t("ADMIN.CONNECTION_HIS_PAGE.LOGOUT_PERIOD")}</div>
                        </div>
                    </div>
                </div>
                {(mix_row.length!==0) && (mix_row!=="no_data")?
                    mix_row.map((res, index)=>{
                        let _user_acc = 0
                        userArray.forEach(user=>{
                            if(res[0].user_id===user.id){ _user_acc = user.email }
                            try{
                                if(res[1].user_id===user.id){ _user_acc = user.email }
                            }
                            catch{}
                        })
                        return <ConnectionHisRow
                            user_acc={_user_acc}
                            index={index}
                            key={index}
                            row={res}
                            nameRow={nameRow}
                            now={_timestamp}
                            toggleConRec={toggleConRec}
                            />})
                    :
                    mix_row==="no_data"?<div className="w-100 mar-15 t fx-ccc">無連線紀錄</div>
                    :<WaitingIcon page={"connection"}/>
                }
                <TenMinutesInterval time_interval={time_interval} width={"w-80"}/>
            </div>
            {(ConnectionRecord[0]? <Connection_His name={ConnectionRecord[1]}/>:null)}
        </div>
    );

}
export default ConnectionHisGraphyNew;

const ConnectionHisRow =(props)=>{
    const {t}=useTranslation()
    let now = props.now
    let nameRow = props.nameRow
    let index = props.index
    let row = props.row
    if(row[0].logout_time===undefined){
        row.unshift({
            created_at:now.getTime(),
            type:row[0].type,
            os:row[0].os,
            logout_time:''
        })}
    return(
        <div className='w-100 fx-d-r min-hig-10' key={index}>
            <div className='w-10 fx-ccc'><div className='h-60 fx-ccc w-100 '>{nameRow[index]}</div></div>
            <div className='w-80 fx-d-r font-s fx-fsc'>
                {row.map((res, index)=>{
                    let timePeriod = parseInt((res.created_at - props.now + ONE_DAY)/1000)
                    let _width = `${(timePeriod*100/(ONE_DAY/1000))*0.8*0.965}%`
                    return  <HoverCard account={props.user_acc} key={index} width={_width} res={res} res_1={(index!==(row.length-1))?row[index+1]:null} />
                })}
            </div>
            <div className='w-10 fx-ccc'>
                <div className='br-10 bgC-light w-60 shadow-xs fx-ccc cursor pt'
                    onClick={()=>{props.toggleConRec(nameRow[index])}}>{t("ADMIN.CONNECTION_HIS_PAGE.HISTORY")}</div>
            </div>
        </div>
    );
}

//  ------ 底下時間軸 -------------------------
export const TenMinutesInterval =(props)=>{
    const {t}=useTranslation()
    let interval = props.time_interval
    return(
        <div className='w-100 fx-d-r br-10 min-hig-10 fx-fsc'>
            <div className='w-10 fx-ccc'><div className='h-60 fx-ccc w-100'>{t("ADMIN.CONNECTION_HIS_PAGE.TIME_LINE")}</div></div>
            <div className={`${props.width} fx-d-r font-s fx-cspbt h-3`}>
                {interval.map((res,index)=>{
                    let _UTC_interval = new Date(res)
                    let _m = _UTC_interval.getMinutes()
                    let _h = _UTC_interval.getHours()
                    return <div className={`${(_m%10===0)? "right_border":""} ${(_m%60===0)?'h-hours right_border_2':'h-minutes'}`} key={index}>
                        <div className='pos-a'>
                            {(_m%60===0)?
                                `${(_h/10>0)?_h:`0${_h}`}:00`
                                :null
                            }
                        </div>
                    </div>
                })}
            </div>
        </div>
    );
}
//  ------ 底下時間軸 -------------------------


//  ------ 每個登入登出區段 -------------------------
const HoverCard =(props)=>{
    const [mouseX, setMouseX] = useState(0);
    const [hoverBtm, setHoverBtm] = useState(false);
    function toggleHover(){ setHoverBtm(!hoverBtm) }
    function getMousePosition(e){
        toggleHover()
        if(e.clientX+300>window.screen.width){
            setMouseX(window.screen.width-650);
        }else{setMouseX(e.clientX-250)}

    }
    return(
        <div style={{width:props.width}}
            onMouseEnter={getMousePosition}
            onMouseLeave={getMousePosition}
            className={`${props.res.logout_time===undefined? "bgC-white":"bgC-light-green"} h-3 pos-a right_border`}>
                {(hoverBtm)? <div className='bgC-white pos-a z-1 hover_card' style={{left:mouseX}}>
                    <div>Account : {props.account}</div>
                    <div>Login time : {(props.res_1!==null)?props.res_1.login_time:null}</div>
                    <div>Logout time : {(props.res!==null)?props.res.logout_time:null}</div>
                    <div>Device : {props.res.type}</div>
                    <div>OS : {props.res.os}</div>
                </div>:null}
        </div>
    )
}
//  ------ 每個登入登出區段 -------------------------
